﻿// Our custom slider used for banners. Elsewhere we use tiny-slider (TNS).

import {$$, $, sendPromotionGtmEvent, Key} from "@/Utils"
import {GtmEventType} from "@/enums";

let isMouseDown = false
let moveStart = 0
let moveDelta = 0
let stepPct = 0
let scrollEnabled = true;
let initialX = null;
let initialY = null;

function dragStart(event: Event) {
    if (!window.isResponsive) return
    const target = event.target as HTMLElement
    const content = target.closest(".image-slider__content") as HTMLElement
    const width = parseFloat(content.style.getPropertyValue("width"))
    if (width === 100) return

    isMouseDown = true

    stepPct = 100 * 100 / width
    content.classList.add("no-drag")
    content.style.setProperty('transition-duration', '0s')
    moveStart = getClientX(event)
    moveDelta = moveStart
}

function getClientX(event: Event) {
    if (event instanceof MouseEvent) {
        return event.clientX
    } else {
        const touchEvent = event as TouchEvent
        return touchEvent.changedTouches[0].clientX
    }
}
function getClientY(event: Event) {
    if (event instanceof MouseEvent) {
        return event.clientY
    } else {
        const touchEvent = event as TouchEvent
        return touchEvent.changedTouches[0].clientY
    }
}

function disableScroll(event: Event) {
    if (scrollEnabled) {
        initialX = getClientX(event);
        initialY = getClientY(event);
        scrollEnabled = false;
        $('body').classList.add("stop-scrolling")
    }


}

function enableScroll() {
    if (!scrollEnabled) {
        scrollEnabled = true;
        $('body').classList.remove("stop-scrolling")
    }
}

function drag(event: Event) {
    if (!isMouseDown) return
    const clientX = getClientX(event)
    const target = event.target as HTMLElement
    if (window.isResponsive && !!target.closest(".modal-cart"))
        return;
    const content = target.closest(".image-slider__content") as HTMLElement
    if (!content){
        enableScroll()
        return;
    }
    const deltaPct = 100 * (clientX - moveDelta) / content.scrollWidth;
    moveDelta = clientX
    const existingTransform = content.style.transform.length ? parseFloat(content.style.transform.split('(')[1].split(')')[0]) : 0
    const newTransform = existingTransform + deltaPct
    content.style.transform = "translateX(" + Math.min(stepPct, Math.max(-100, newTransform)) + "%)"
    if (initialX == null) {
        initialX = clientX
    }
    let clientY = getClientY(event)
    if (initialY == null) {
        initialY = clientY
    }
    // If users scrolls and moves left or right by X px 
    // then we conclude that user is swiping. 100px is max tolerance.
    const tolerance = Math.min(100, 0.15 * window.innerWidth);
    if (Math.abs(clientX - initialX) > tolerance) {
        disableScroll(event)
    }
    else if(Math.abs(clientY - initialY) > tolerance){
        enableScroll()
    }
}
function dragStop(event: Event) {
    if (!isMouseDown) return
    const target = event.target as HTMLElement
    if (window.isResponsive && !!target.closest(".modal-cart"))
        return;
    const content = target.closest(".image-slider__content") as HTMLElement
    content.classList.remove("no-drag")
    content.style.removeProperty("transition-duration")
    const slider = content.closest(".image-slider")
    if (Math.abs(moveDelta - moveStart) > 5) {
        advanceActiveIndex(slider, getClientX(event) > moveStart)
    } else {
        (content.querySelector(".image-slider__item--active") as HTMLElement).click();
        (slider.querySelector(".nav--active") as HTMLElement).click()
    }
    isMouseDown = false
}

function enableScrollIfTouchOutsideOfTheSlider(e) {
    if (!(<HTMLElement>e.target).classList.contains("image-slider__img")) {
        enableScroll()
    }
}

export function initSliders() {
    document.addEventListener("mousedown", enableScrollIfTouchOutsideOfTheSlider)
    document.addEventListener("touchstart", enableScrollIfTouchOutsideOfTheSlider)
    $$(".image-slider").forEach(slider => {
        const smallMedia = slider.hasAttribute("data-small-media")
        const needToBind = !smallMedia || window.isResponsive

        if (needToBind === slider.hasAttribute("data-bound")) {
            return
        }

        const content = slider.querySelector(".image-slider__content") as HTMLElement

        if (needToBind) {
            slider.setAttribute("data-bound", "true")
        }
        else {
            slider.removeAttribute("data-bound")
            content.style.removeProperty("width")
            content.style.removeProperty("transform")
            return
        }
        let calculatedWidth = content.children.length * 100
        if (slider.hasAttribute("data-additional-products")) {
            calculatedWidth /= 3
        }
        content.style.width = calculatedWidth + "%"

        if (content.hasAttribute("data-listeners-bound")) return
        content.setAttribute("data-listeners-bound", "")
        content.addEventListener("mousedown", dragStart)
        content.addEventListener("touchstart", dragStart)
        document.body.addEventListener("mousemove", drag)
        document.body.addEventListener("touchmove", drag)
        content.addEventListener("mouseup", dragStop)
        content.addEventListener("touchend", dragStop)
        content.addEventListener("mouseout", dragStop)
        content.addEventListener("click", (ev: Event) => { if (Math.abs(moveDelta - moveStart) > 5) { ev.preventDefault() } })
        content.querySelectorAll("img").forEach(x => x.addEventListener("mousedown", (ev: Event) => ev.preventDefault()))

        const nav = slider.querySelector(".nav")
        if (nav) {
            const activeNav = nav.querySelector(".nav--active") || nav.querySelector(".nav__goto")
            activeNav.classList.add("nav--active")
            activeNav.setAttribute("tabindex", "0")
        }
        const sliderContainer = slider.querySelector(".image-slider__content")
        const activeItem = (sliderContainer.querySelector(".image-slider__item--active") || sliderContainer.querySelector(".image-slider__item")) as HTMLElement
        activeItem.classList.add("image-slider__item--active")
        activeItem.querySelector("[tabindex]")?.removeAttribute("tabindex")

        const prev = slider.querySelector(".prev") as HTMLElement
        const next = slider.querySelector(".next") as HTMLElement
        if (prev && next) {
            prev.addEventListener("click", () => advanceActiveIndex(slider, true, null, false))
            prev.addEventListener("keydown", (e) => {
                if (e.key !== Key.Enter && e.key !== Key.Space && e.key !== Key.SpaceAlt) {
                    return;
                }
                advanceActiveIndex(slider, true, null, false);
            })
            next.addEventListener("click", () => advanceActiveIndex(slider, false, null, false))
            next.addEventListener("keydown", (e: KeyboardEvent) => {
                if (e.key !== Key.Enter && e.key !== Key.Space && e.key !== Key.SpaceAlt) {
                    return;
                }
                advanceActiveIndex(slider, false, null, false);
            })
        }

        const autoplayMs = parseInt(slider.getAttribute("data-autoplay"))
        if (autoplayMs && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            window.setInterval(() => {
                if (!slider.querySelector(":hover, :focus")) { advanceActiveIndex(slider, false, null, false) }
            }, autoplayMs)
        }

        slider.querySelectorAll(".nav__goto").forEach((g, i) => {
            g.addEventListener("click", () => advanceActiveIndex(slider, false, i))
            g.addEventListener("keydown", (e: KeyboardEvent) => {
                if(e.key === Key.ArrowRight){
                    advanceActiveIndex(slider, false)
                    return
                }
                else if(e.key === Key.ArrowLeft){
                    advanceActiveIndex(slider, true)
                    return
                }
                else if (e.key !== Key.Enter && e.key !== Key.Space && e.key !== Key.SpaceAlt) {
                    return
                }
                advanceActiveIndex(slider, false, i)
            })
        })
    })
}


function advanceActiveIndex(slider: Element, reverse: boolean, advanceIdx: number = null, setFocus: boolean = true) {
    if (!window.isResponsive && slider.hasAttribute("data-small-media")) return;

    const slideBy = slider.hasAttribute("data-additional-products") ? 2 : 1
    const content = slider.querySelector(".image-slider__content") as HTMLElement
    const items = content.children.length

    if (slideBy === 1 && items < 2) return
    if (slideBy === 2 && items < 4) return

    const sliderContainer = slider.querySelector(".image-slider__content")
    const activeItem = (sliderContainer.querySelector(".image-slider__item--active") || sliderContainer.querySelector(".image-slider__item")) as HTMLElement
    const idx = Array.from(sliderContainer.children).indexOf(activeItem)

    if (advanceIdx === null) {
        advanceIdx = reverse
            ? idx < slideBy ? items - (slideBy > 1 ? 3 : 1) : idx - slideBy
            : idx > items - (slideBy > 1 ? 4 : 2) ? 0 : idx + slideBy
    }
    content.style.transform = "translateX(" + -100 * advanceIdx / items + "%)"

    activeItem.classList.remove("image-slider__item--active")
    activeItem.querySelector("a")?.setAttribute("tabindex","-1")
    sliderContainer.children[advanceIdx].classList.add("image-slider__item--active")
    sliderContainer.children[advanceIdx].querySelector("[tabindex]")?.removeAttribute("tabindex")
    const nav = slider.querySelector(".nav")
    if (nav) {
        const activeNav = nav.querySelector(".nav--active") || nav.querySelector(".nav__goto")
        activeNav.classList.remove("nav--active")
        activeNav.setAttribute("tabindex", "-1")
        const nextNav = nav.children[advanceIdx] as HTMLElement
        if (nextNav) {
            nextNav.classList.add("nav--active")
            nextNav.setAttribute("tabindex", "0")
            if (setFocus) {
                nextNav.focus()
            }
        }
    }

    const bannerImage = activeItem.querySelector("img");
    sendPromotionGtmEvent(bannerImage, GtmEventType.ViewPromotion);
}